// Pre-loaded parsed statement from Indian Overseas Bank (PRATHITHA DIGITAL PRINTERS - Aug 2026)
// Total 105 transactions: 46 Debits (Rs. 42,975.62), 59 Credits (Rs. 44,390.00)

export interface RawStatementEntry {
  date: string;
  description: string;
  refNo: string;
  debit: number;
  credit: number;
  balance: number;
}

export const AUGUST_2026_IOB_STATEMENT: RawStatementEntry[] = [
  {
    "date": "31-Aug-26",
    "description": "UPI/624379317208/DR/SREE MANIKANDA/CNR/Pay to Me",
    "refNo": "S35790101",
    "debit": 30,
    "credit": 0,
    "balance": 44776.66
  },
  {
    "date": "31-Aug-26",
    "description": "UPI/100717409712/CR/ R MOHAN/SBI /Pay to PP",
    "refNo": "S33878437",
    "debit": 0,
    "credit": 350,
    "balance": 44806.66
  },
  {
    "date": "31-Aug-26",
    "description": "UPI/100716464172/CR/ R MOHAN/SBI /Pay to PP",
    "refNo": "S23889982",
    "debit": 0,
    "credit": 500,
    "balance": 44456.66
  },
  {
    "date": "30-Aug-26",
    "description": "UPI/660842948342/DR/District by Zo /HDF/Pay via R",
    "refNo": "S17929503",
    "debit": 438.4,
    "credit": 0,
    "balance": 43956.66
  },
  {
    "date": "30-Aug-26",
    "description": "UPI/660824367063/DR/Raja stores an /YES/UPI",
    "refNo": "S17432537",
    "debit": 2383,
    "credit": 0,
    "balance": 44395.06
  },
  {
    "date": "30-Aug-26",
    "description": "UPI/660803359614/DR /JEYACHANDRAN R/YES/Payment f",
    "refNo": "S16529466",
    "debit": 370,
    "credit": 0,
    "balance": 46778.06
  },
  {
    "date": "30-Aug-26",
    "description": "UPI/128731584675/CR/ SURENDIRA A S/IND/UPI",
    "refNo": "S89037999",
    "debit": 0,
    "credit": 350,
    "balance": 47148.06
  },
  {
    "date": "29-Aug-26",
    "description": "UPI/736920172416/DR/ Google Play/uti /MandateEx",
    "refNo": "S79987521",
    "debit": 1950,
    "credit": 0,
    "balance": 46798.06
  },
  {
    "date": "29-Aug-26",
    "description": "UPI/128712107067/CR/ SURENDIRA A S/IND/UPI",
    "refNo": "S78285418",
    "debit": 0,
    "credit": 500,
    "balance": 48748.06
  },
  {
    "date": "29-Aug-26",
    "description": "UPI/624194860351/CR/ S VISWANATHAN/ICI/Sai Krish",
    "refNo": "S69553502",
    "debit": 0,
    "credit": 2000,
    "balance": 48248.06
  },
  {
    "date": "29-Aug-26",
    "description": "UPI/660713124935/CR/Mr Gnanavel Ve /IDI/UPI",
    "refNo": "S67840024",
    "debit": 0,
    "credit": 700,
    "balance": 46248.06
  },
  {
    "date": "29-Aug-26",
    "description": "UPI/660782021705/CR/Mr Gnanavel Ve /IDI/UPI",
    "refNo": "S65563561",
    "debit": 0,
    "credit": 4620,
    "balance": 45548.06
  },
  {
    "date": "29-Aug-26",
    "description": "UPI/499823351636/CR/ Mr SURESH G /IDI/Payment f",
    "refNo": "S61543110",
    "debit": 0,
    "credit": 400,
    "balance": 40928.06
  },
  {
    "date": "28-Aug-26",
    "description": "UPI/624024309051/DR/Mr Sakthivel R /CIU/UPI",
    "refNo": "S49571695",
    "debit": 76,
    "credit": 0,
    "balance": 40528.06
  },
  {
    "date": "28-Aug-26",
    "description": "UPI/128648178269/CR/ P ELANGO/IOB /UPI",
    "refNo": "S42629711",
    "debit": 0,
    "credit": 500,
    "balance": 40604.06
  },
  {
    "date": "28-Aug-26",
    "description": "UPI/128643196359/CR/VISHVESHWAR DU/ICI/MLA Desig",
    "refNo": "S40367361",
    "debit": 0,
    "credit": 250,
    "balance": 40104.06
  },
  {
    "date": "28-Aug-26",
    "description": "UPI/660623982409/DR /SAMBATHKUMAR /UTI/UPI",
    "refNo": "S39512915",
    "debit": 57,
    "credit": 0,
    "balance": 39854.06
  },
  {
    "date": "28-Aug-26",
    "description": "UPI/660689971420/DR/ Dinesh M/YES /UPI",
    "refNo": "S38955301",
    "debit": 50,
    "credit": 0,
    "balance": 39911.06
  },
  {
    "date": "27-Aug-26",
    "description": "UPI/660550437979/DR/Mercury Agenci /YES/UPI",
    "refNo": "S23733882",
    "debit": 500,
    "credit": 0,
    "balance": 39961.06
  },
  {
    "date": "27-Aug-26",
    "description": "UPI/128597695169/CR/ SURERESH BABU A/HSB/UPI",
    "refNo": "S16591244",
    "debit": 0,
    "credit": 1400,
    "balance": 40461.06
  },
  {
    "date": "27-Aug-26",
    "description": "UPI/623986496950/DR/ajenithpr@okic /IND/UPI",
    "refNo": "S15518699",
    "debit": 78,
    "credit": 0,
    "balance": 39061.06
  },
  {
    "date": "27-Aug-26",
    "description": "UPI/623954599469/DR/PRINTONE GIFTS/UTI/UPI",
    "refNo": "S14143474",
    "debit": 2853,
    "credit": 0,
    "balance": 39139.06
  },
  {
    "date": "27-Aug-26",
    "description": "UPI/660502232304/CR/SAKTHIVEL GOV/UJV/UPI",
    "refNo": "S12584956",
    "debit": 0,
    "credit": 1000,
    "balance": 41992.06
  },
  {
    "date": "27-Aug-26",
    "description": "UPI/660520414844/CR/ SIVASHANKAR P/HSB/UPI",
    "refNo": "S97630715",
    "debit": 0,
    "credit": 2000,
    "balance": 40992.06
  },
  {
    "date": "26-Aug-26",
    "description": "UPI/623885726469/CR/Nandhakishore /SBI/Paid via",
    "refNo": "S81785736",
    "debit": 0,
    "credit": 400,
    "balance": 38992.06
  },
  {
    "date": "26-Aug-26",
    "description": "UPI/623803323898/DR/aanandanand14@ /CNR/UPI",
    "refNo": "S74578664",
    "debit": 300,
    "credit": 0,
    "balance": 38592.06
  },
  {
    "date": "26-Aug-26",
    "description": "UPI/623882803495/DR/ FINWISE AUDIT/HDF/UPI",
    "refNo": "S73054944",
    "debit": 512,
    "credit": 0,
    "balance": 38892.06
  },
  {
    "date": "26-Aug-26",
    "description": "UPI/623850210305/CR/SAKTHIVEL GOV/UJV/UPI",
    "refNo": "S69352843",
    "debit": 0,
    "credit": 1000,
    "balance": 39404.06
  },
  {
    "date": "26-Aug-26",
    "description": "UPI/623886209892/CR/ROOBAN FRANCIS/UTI/UPI",
    "refNo": "S69029488",
    "debit": 0,
    "credit": 800,
    "balance": 38404.06
  },
  {
    "date": "25-Aug-26",
    "description": "UPI/660340170209/DR/ SELVI S/UTI /UPI",
    "refNo": "S62887827",
    "debit": 150,
    "credit": 0,
    "balance": 37604.06
  },
  {
    "date": "25-Aug-26",
    "description": "UPI/660378376268/DR/Murali fresh j /YES/UPI",
    "refNo": "S62227093",
    "debit": 50,
    "credit": 0,
    "balance": 37754.06
  },
  {
    "date": "25-Aug-26",
    "description": "UPI/660351154088/DR/santhoshkee89- /BKI/UPI",
    "refNo": "S51175245",
    "debit": 78,
    "credit": 0,
    "balance": 37804.06
  },
  {
    "date": "25-Aug-26",
    "description": "UPI/128489344354/CR/VISHVESHWAR DU/ICI/Posters",
    "refNo": "S49473010",
    "debit": 0,
    "credit": 200,
    "balance": 37882.06
  },
  {
    "date": "25-Aug-26",
    "description": "UPI/660312725802/DR/PRINTONE GIFTS/UTI/UPI",
    "refNo": "S44974606",
    "debit": 930,
    "credit": 0,
    "balance": 37682.06
  },
  {
    "date": "25-Aug-26",
    "description": "UPI/660327619739/DR/ NALAM ANGADI/KKB/UPI",
    "refNo": "S41344903",
    "debit": 265,
    "credit": 0,
    "balance": 38612.06
  },
  {
    "date": "24-Aug-26",
    "description": "UPI/128436273856/CR/ROOBAN FRANCIS/HDF/UPI",
    "refNo": "S21107398",
    "debit": 0,
    "credit": 500,
    "balance": 38877.06
  },
  {
    "date": "24-Aug-26",
    "description": "UPI/623670564849/DR/jaiganesh3680- /BDB/UPI",
    "refNo": "S19108468",
    "debit": 100,
    "credit": 0,
    "balance": 38377.06
  },
  {
    "date": "24-Aug-26",
    "description": "UPI/623679763401/DR/ Mrs Devi/IDI /UPI",
    "refNo": "S18152735",
    "debit": 554,
    "credit": 0,
    "balance": 38477.06
  },
  {
    "date": "24-Aug-26",
    "description": "UPI/623618158799/DR/ASHIK BRIYANI /YES/UPI",
    "refNo": "S17521105",
    "debit": 130,
    "credit": 0,
    "balance": 39031.06
  },
  {
    "date": "24-Aug-26",
    "description": "UPI/623607437088/DR/SARVODAYA PAPE/KKB/2319642A",
    "refNo": "S15422414",
    "debit": 8909,
    "credit": 0,
    "balance": 39161.06
  },
  {
    "date": "24-Aug-26",
    "description": "UPI/623614039565/DR/balabala57737- /SBI/UPI",
    "refNo": "S12797965",
    "debit": 200,
    "credit": 0,
    "balance": 48070.06
  },
  {
    "date": "24-Aug-26",
    "description": "UPI/623684352851/DR/Deepan Thanga /SBI/UPI",
    "refNo": "S12463735",
    "debit": 160,
    "credit": 0,
    "balance": 48270.06
  },
  {
    "date": "22-Aug-26",
    "description": "UPI/660018731410/DR/ SUGANTHI G /YES/UPI",
    "refNo": "S70718690",
    "debit": 170,
    "credit": 0,
    "balance": 48430.06
  },
  {
    "date": "22-Aug-26",
    "description": "UPI/660028844729/DR/ MADAN/YES /UPI",
    "refNo": "S68668979",
    "debit": 430,
    "credit": 0,
    "balance": 48600.06
  },
  {
    "date": "22-Aug-26",
    "description": "UPI/660010003917/DR/jaiganesh3680- /BDB/UPI",
    "refNo": "S54235738",
    "debit": 100,
    "credit": 0,
    "balance": 49030.06
  },
  {
    "date": "21-Aug-26",
    "description": "UPI/623431349302/DR/Murali fresh j /YES/UPI",
    "refNo": "S43532070",
    "debit": 50,
    "credit": 0,
    "balance": 49130.06
  },
  {
    "date": "21-Aug-26",
    "description": "UPI/623390343708/CR/VISHVESHWAR DU/KVB/Poster De",
    "refNo": "S38337921",
    "debit": 0,
    "credit": 350,
    "balance": 49180.06
  },
  {
    "date": "21-Aug-26",
    "description": "UPI/623331047652/CR/ JAGANNATHAN B/HDF/UPI Send",
    "refNo": "S30067500",
    "debit": 0,
    "credit": 1150,
    "balance": 48830.06
  },
  {
    "date": "21-Aug-26",
    "description": "UPI/623346927442/DR/ SURESH V/PUN /UPI",
    "refNo": "S26763282",
    "debit": 700,
    "credit": 0,
    "balance": 47680.06
  },
  {
    "date": "21-Aug-26",
    "description": "UPI/659951534443/CR/ JEGAN A/KKB /UPI",
    "refNo": "S24155478",
    "debit": 0,
    "credit": 300,
    "balance": 48380.06
  },
  {
    "date": "21-Aug-26",
    "description": "UPI/128262714888/CR/ ARIVALAGAN R/IOB/UPI",
    "refNo": "S23127887",
    "debit": 0,
    "credit": 1300,
    "balance": 48080.06
  },
  {
    "date": "20-Aug-26",
    "description": "UPI/623220992366/CR/ JAGANNATHAN B/HDF/UPI Send",
    "refNo": "S89944298",
    "debit": 0,
    "credit": 1000,
    "balance": 46780.06
  },
  {
    "date": "20-Aug-26",
    "description": "UPI/659809034064/DR/ RAFIK BASHA M/IOB/Banner",
    "refNo": "S83121586",
    "debit": 3300,
    "credit": 0,
    "balance": 45780.06
  },
  {
    "date": "19-Aug-26",
    "description": "UPI/128177253858/CR/ Mr RSanthosh /IDI/UPI",
    "refNo": "S66703472",
    "debit": 0,
    "credit": 600,
    "balance": 49080.06
  },
  {
    "date": "18-Aug-26",
    "description": "UPI/659670686305/CR/HARIDASS SEETH/UTI/Paid via",
    "refNo": "S38497728",
    "debit": 0,
    "credit": 300,
    "balance": 48480.06
  },
  {
    "date": "17-Aug-26",
    "description": "UPI/128086590542/CR/VISHVESHWAR DU/ICI/Banner",
    "refNo": "S19437307",
    "debit": 0,
    "credit": 200,
    "balance": 48180.06
  },
  {
    "date": "17-Aug-26",
    "description": "UPI/659565266292/CR/ SELVA V/HDF /flex",
    "refNo": "S98676723",
    "debit": 0,
    "credit": 1100,
    "balance": 47980.06
  },
  {
    "date": "15-Aug-26",
    "description": "UPI/127964971613/CR/ GOPI B/TMB /UPI",
    "refNo": "S45922653",
    "debit": 0,
    "credit": 500,
    "balance": 46880.06
  },
  {
    "date": "15-Aug-26",
    "description": "UPI/127951307200/CR/ GOPI B/TMB /UPI",
    "refNo": "S38244034",
    "debit": 0,
    "credit": 1000,
    "balance": 46380.06
  },
  {
    "date": "14-Aug-26",
    "description": "UPI/127923449608/CR/VISHVESHWAR DU/HDF/Poster",
    "refNo": "S23088435",
    "debit": 0,
    "credit": 100,
    "balance": 45380.06
  },
  {
    "date": "14-Aug-26",
    "description": "UPI/127921219531/CR/Ms Abirami Ram /CIU/UPI",
    "refNo": "S21742793",
    "debit": 0,
    "credit": 300,
    "balance": 45280.06
  },
  {
    "date": "14-Aug-26",
    "description": "UPI/622612010140/CR/ROOBAN FRANCIS/UTI/UPI",
    "refNo": "S11115240",
    "debit": 0,
    "credit": 400,
    "balance": 44980.06
  },
  {
    "date": "14-Aug-26",
    "description": "UPI/622611011133/CR/ Mr SANJAY A /CIU/UPI",
    "refNo": "S95655783",
    "debit": 0,
    "credit": 1000,
    "balance": 44580.06
  },
  {
    "date": "14-Aug-26",
    "description": "UPI/659256976518/CR/ Mr SANJAY A /CIU/invitatio",
    "refNo": "S95631827",
    "debit": 0,
    "credit": 2000,
    "balance": 43580.06
  },
  {
    "date": "13-Aug-26",
    "description": "UPI/659107624978/CR/ JEGAN A/KKB /UPI",
    "refNo": "S73248753",
    "debit": 0,
    "credit": 400,
    "balance": 41580.06
  },
  {
    "date": "13-Aug-26",
    "description": "UPI/659125027515/CR/ Mr VADIVEL S /IDI/UPI",
    "refNo": "S73050050",
    "debit": 0,
    "credit": 280,
    "balance": 41180.06
  },
  {
    "date": "13-Aug-26",
    "description": "UPI/659195310463/CR/ Mr VADIVEL S /IDI/UPI",
    "refNo": "S71508729",
    "debit": 0,
    "credit": 500,
    "balance": 40900.06
  },
  {
    "date": "13-Aug-26",
    "description": "UPI/659154367849/DR/SRI KUMARAN KU/YES/UPI",
    "refNo": "S65741289",
    "debit": 500,
    "credit": 0,
    "balance": 40400.06
  },
  {
    "date": "13-Aug-26",
    "description": "UPI/659155747390/DR/PRINTONE GIFTS/UTI/Invitatio",
    "refNo": "S63761331",
    "debit": 1774,
    "credit": 0,
    "balance": 40900.06
  },
  {
    "date": "12-Aug-26",
    "description": "UPI/659017139293/DR/ S MINNAL KODY/YES/UPI",
    "refNo": "S59364540",
    "debit": 155,
    "credit": 0,
    "balance": 42674.06
  },
  {
    "date": "12-Aug-26",
    "description": "UPI/659071092567/CR/ Mr PRATHAP S /CIU/UPI",
    "refNo": "S42103830",
    "debit": 0,
    "credit": 2000,
    "balance": 42829.06
  },
  {
    "date": "12-Aug-26",
    "description": "UPI/622463263175/DR /PALANIMURUGAN /YES/UPI",
    "refNo": "S30947814",
    "debit": 12,
    "credit": 0,
    "balance": 40829.06
  },
  {
    "date": "11-Aug-26",
    "description": "UPI/622327440459/CR/S.Ankitha Pri/IDF /UPI",
    "refNo": "S25894845",
    "debit": 0,
    "credit": 310,
    "balance": 40841.06
  },
  {
    "date": "11-Aug-26",
    "description": "UPI/622321753322/DR/Mahabunisha Sa /YES/UPI",
    "refNo": "S24048406",
    "debit": 90,
    "credit": 0,
    "balance": 40531.06
  },
  {
    "date": "11-Aug-26",
    "description": "UPI/127750367641/CR/VISHVESHWAR DU/HDF/Sathish B",
    "refNo": "S16277837",
    "debit": 0,
    "credit": 150,
    "balance": 40621.06
  },
  {
    "date": "10-Aug-26",
    "description": "UPI/658879763999/DR/MAHARAJA STICK/KKB/2062762A",
    "refNo": "S81033360",
    "debit": 11040,
    "credit": 0,
    "balance": 40471.06
  },
  {
    "date": "10-Aug-26",
    "description": "UPI/127698685345/CR/ ASHOKJOEL B /CNR/banner",
    "refNo": "S77883953",
    "debit": 0,
    "credit": 420,
    "balance": 51511.06
  },
  {
    "date": "10-Aug-26",
    "description": "UPI/658868538156/CR/Mr Prakash Pal /CIU/UPI",
    "refNo": "S76198954",
    "debit": 0,
    "credit": 100,
    "balance": 51091.06
  },
  {
    "date": "10-Aug-26",
    "description": "UPI/658816008681/CR/Mr Prakash Pal /CIU/UPI",
    "refNo": "S69057374",
    "debit": 0,
    "credit": 500,
    "balance": 50991.06
  },
  {
    "date": "10-Aug-26",
    "description": "UPI/658872239075/DR/Hot Chips Chro /YES/UPI",
    "refNo": "S68049708",
    "debit": 182,
    "credit": 0,
    "balance": 50491.06
  },
  {
    "date": "09-Aug-26",
    "description": "UPI/622102680869/DR/New kirshna Bh /YES/UPI",
    "refNo": "S51569151",
    "debit": 120,
    "credit": 0,
    "balance": 50673.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/622014816017/DR /LAKSHMIKANTH A/TMB/UPI",
    "refNo": "S33193122",
    "debit": 240,
    "credit": 0,
    "balance": 50793.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/658689769715/DR/ Blinkit/HDF /UPIIntent",
    "refNo": "S17355015",
    "debit": 247,
    "credit": 0,
    "balance": 51033.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/658604675127/CR/MUNUSAMY ELUMA/YES/UPI",
    "refNo": "S16599428",
    "debit": 0,
    "credit": 1000,
    "balance": 51280.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/658644557006/DR/ Blinkit/HDF /UPIIntent",
    "refNo": "S16458213",
    "debit": 247,
    "credit": 0,
    "balance": 50280.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/622035569909/CR/ VIGNESH R/SBI /UPI",
    "refNo": "S15551315",
    "debit": 0,
    "credit": 200,
    "balance": 50527.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/658629058579/DR/jaiganesh3680- /BDB/UPI",
    "refNo": "S15402950",
    "debit": 100,
    "credit": 0,
    "balance": 50327.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/658606963886/CR/ ARUNKUMAR M/HDF/UPI",
    "refNo": "S14872618",
    "debit": 0,
    "credit": 100,
    "balance": 50427.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/658618567312/CR /VIATHEESHWARI /UBI/UPI",
    "refNo": "S14840841",
    "debit": 0,
    "credit": 300,
    "balance": 50327.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/658633872766/CR /VIATHEESHWARI /UBI/UPI",
    "refNo": "S12926210",
    "debit": 0,
    "credit": 500,
    "balance": 50027.06
  },
  {
    "date": "08-Aug-26",
    "description": "UPI/127562798573/CR/DHANASEKAR KAN/IOB/UPI",
    "refNo": "S10290033",
    "debit": 0,
    "credit": 500,
    "balance": 49527.06
  },
  {
    "date": "07-Aug-26",
    "description": "UPI/658604849902/DR/9361254924@pty /CNR/UPI",
    "refNo": "S94973954",
    "debit": 70,
    "credit": 0,
    "balance": 49027.06
  },
  {
    "date": "07-Aug-26",
    "description": "UPI/658662627427/DR/AATIF MEAT MAR/HDF/UPI",
    "refNo": "S94916557",
    "debit": 880,
    "credit": 0,
    "balance": 49097.06
  },
  {
    "date": "07-Aug-26",
    "description": "UPI/658589027670/CR/ VIGNESH R/SBI /UPI",
    "refNo": "S94527292",
    "debit": 0,
    "credit": 350,
    "balance": 49977.06
  },
  {
    "date": "07-Aug-26",
    "description": "UPI/621901173363/CR/ VIGNESH R/SBI /UPI",
    "refNo": "S90346006",
    "debit": 0,
    "credit": 1100,
    "balance": 49627.06
  },
  {
    "date": "07-Aug-26",
    "description": "UPI/621941297934/CR /RAJAKUMARAN V/SBI/UPI",
    "refNo": "S82865805",
    "debit": 0,
    "credit": 1500,
    "balance": 48527.06
  },
  {
    "date": "06-Aug-26",
    "description": "UPI/621843936964/CR/Mr Unni Krishn /CIU/UPI",
    "refNo": "S65168775",
    "debit": 0,
    "credit": 250,
    "balance": 47027.06
  },
  {
    "date": "06-Aug-26",
    "description": "UPI/621826104922/CR/ SANJAY A/CIU /TVK invit",
    "refNo": "S54544237",
    "debit": 0,
    "credit": 1000,
    "balance": 46777.06
  },
  {
    "date": "05-Aug-26",
    "description": "UPI/658334969075/CR/ Jayakumar K/ESF /UPI",
    "refNo": "S36417334",
    "debit": 0,
    "credit": 800,
    "balance": 45777.06
  },
  {
    "date": "03-Aug-26",
    "description": "POS-GOOGLE WORKSPACE CYBS SI 2240920005 IN-V50685",
    "refNo": "S52769987",
    "debit": 1227.2,
    "credit": 0,
    "balance": 44977.06
  },
  {
    "date": "02-Aug-26",
    "description": "UPI/621407280323/CR/DINESH KUMAR P/SBI/UPI",
    "refNo": "S29819962",
    "debit": 0,
    "credit": 250,
    "balance": 46204.26
  },
  {
    "date": "02-Aug-26",
    "description": "UPI/621480877458/CR/DINESH KUMAR P/SBI/UPI",
    "refNo": "S18921349",
    "debit": 0,
    "credit": 250,
    "balance": 45954.26
  },
  {
    "date": "02-Aug-26",
    "description": "UPI/621465285193/CR/ SAPNA VARMA /DLX/DrVarma",
    "refNo": "S17911712",
    "debit": 0,
    "credit": 800,
    "balance": 45704.26
  },
  {
    "date": "01-Aug-26",
    "description": "UPI/069158399197/CR/YatraaDarshini /CIU/Standee 6",
    "refNo": "S76164519",
    "debit": 0,
    "credit": 1760,
    "balance": 44904.26
  },
  {
    "date": "01-Aug-26",
    "description": "UPI/657952969058/DR/District Movie /HDF/UPIIntent",
    "refNo": "S74026493",
    "debit": 218.02,
    "credit": 0,
    "balance": 43144.26
  }
];
